import "./index.css";
export const ClosedBusinessTabs = ({ name, key, onClick }) => {
  return (
    <div className="closed-business-tabs" key={key} onClick={onClick}>
      <p>{name}</p>
    </div>
  );
};













